import { NOT_SET } from '@/src/utils/tracking';

export const getScreenName = (landingType) => {
  switch (landingType) {
    case 'CAMPAIGN':
      return 'campaign_landing';
    case 'AAS':
      return 'aas_landing';
    case 'AUTO_PAYMENT_METHOD':
      return 'incentives_pm_landing';
    case 'AUTO_VOUCHER':
      return 'incentives_voucher_landing';
    default:
      return 'campaign_landing';
  }
};

export const getSortingSelect = (sortingSelected) => {
  switch (sortingSelected) {
    case 'RANKING':
      return 'recommended';
    case 'DISTANCE':
      return 'nearest';
    case 'DELIVERY_TIME':
      return 'delivery_time';
    default:
      return 'recommended';
  }
};

export const getPromisedDeliveryTimes = (deliveryTime) => {
  const deliveryAttributes = {
    promisedDeliveryTime: NOT_SET,
    promisedDeliveryTimeRangeLower: NOT_SET,
    promisedDeliveryTimeRangeUpper: NOT_SET,
  };

  if (!deliveryTime || typeof deliveryTime !== 'string') {
    return deliveryAttributes;
  }

  if (deliveryTime.includes('-')) {
    const parts = deliveryTime.split('-');
    const lower = parseInt(parts[0], 10);
    const upper = parseInt(parts[1], 10);

    if (!Number.isNaN(lower) && !Number.isNaN(upper)) {
      deliveryAttributes.promisedDeliveryTimeRangeLower = lower;
      deliveryAttributes.promisedDeliveryTimeRangeUpper = upper;
    }
  } else {
    const singleTime = parseInt(deliveryTime, 10);

    if (!Number.isNaN(singleTime)) {
      deliveryAttributes.promisedDeliveryTime = singleTime;
    }
  }
  return deliveryAttributes;
};
